import Splide from "@splidejs/splide";
import GLightbox from "glightbox";

class ProductGallery {
	constructor() {
		this.thumbnailSlider = document.querySelector(".jsMainThumbnails");
		this.mainSlider = document.querySelector(".jsMainGallery");
		this.fabricRadios = document.querySelectorAll(".configuratorField-fabricId");

		if (this.mainSlider) {
			this.initializeMainSlider();
		}

		if (this.thumbnailSlider) {
			this.initializeThumbnailSlider();
		}

		if (this.thumbnailSlider && this.mainSlider) {
			this.initializeLightbox();
			this.initializeConfiguratorSlider();
		}

		// if(this.fabricRadios.length) {
		// 	this.fabricRadios.forEach((fabric) => {
		// 		fabric.addEventListener("click", (e) => this.onFabricChanged(e.target));
		// 	});
		// }
		
		window.addEventListener("fabricChanged", () => {
			this.fabricRadios.forEach(radio => {
				if(radio.checked) {
					this.onFabricChanged(radio)
				}
			})
		})
	}

	initializeLightbox() {
		this.lightbox = GLightbox({
			loop: true,
			openEffect: "fade",
			closeEffect: "fade",
		});
	}

	initializeThumbnailSlider() {
		this.thumbnails = new Splide(this.thumbnailSlider, {
			rewind: true,
			perPage: 4,
			isNavigation: true,
			gap: 10,
			pagination: false,
			breakpoints: {
				399: {
					perPage: 3,
				},
			},
		});
	}

	initializeMainSlider() {
		this.main = new Splide(this.mainSlider, {
			rewind: true,
			type: "loop",
			heightRatio: 1,
			pagination: false,
			arrows: false,
			perPage: 1,
		});
	}

	initializeConfiguratorSlider() {
		this.main.sync(this.thumbnails);
		this.main.mount();
		this.thumbnails.mount();

		this.lightbox.on("slide_changed", ({ prev, current }) => {
			this.main.go(current.index);
		});
	}

	onFabricChanged(target) {
		const slides = this.thumbnails.Components.Slides.get(true);		
		const fabricImageId = target.dataset.fabricimageid;

		const fabricSlide = slides.filter(row => {
			return row.slide.dataset.id == `${fabricImageId}`
		});

		this.thumbnails.go(fabricSlide[0].index);
	}
}

export default ProductGallery;
